// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2TaH8","log":"ModalInventoryLogs_log__2SfY-","date":"ModalInventoryLogs_date__1wPin","userName":"ModalInventoryLogs_userName__2yLHP"};